import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Product from '../../components/product/Product';

class AddToCart extends React.Component {

    state = {
        product: null
    }

    componentDidMount() {
		this.setState({
            product: productData
        });
    }

    render() {
        const {props: {basket: {items, totalPrice}}, state: {product}} = this;

        if (product === null) {
            return null;
        }
        
        const basketItemArr = items.filter( i => i.catalogNumber === product.catalogNumber );
		const qty = basketItemArr.length > 0 ? basketItemArr[0].qty : 0;

		return <Product isForDetail={true} qty={qty} product={product} />;
    }
}

const mapStateToProps = (state) => ({
    basket: state.basket
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddToCart);